<template>
    <loading></loading>
</template>

<script>
export default {
    name : "LoginAsUser",
    beforeCreate() {
        window.localStorage.setItem('token', this.$route.params.token);
        window.location.href = '/';
    }
}
</script>
